<template>
  <div class="animated fadeIn pb-8">
    <div v-if="!loaded" class="d-flex flex-column align-items-center mt-8 py-6">
      <atom-spinner :animation-duration="1000" :size="80" :color="'#EF6C00'" />
      <p class="primary--text font-weight-bold mt-4">
        در حال بارگذاری اطلاعات...
      </p>
    </div>
    <div v-else>
      <v-card class="common-card">
        <div class="d-flex flex-row">
          <h4 class="c-grey pt-2 ps-2">فروش‌های آنلاین</h4>
        </div>
        <hr class="mb-0 pb-0" />
        <v-card flat>
          <v-container>
            <v-row class="mt-6 flex-md-row flex-sm-column">
              <v-col
                class="c-grey d-flex flex-column flex-sm-column flex-md-row flex-wrap"
              >
                <div class="custom-input d-flex flex-column flex-md-row">
                  <v-text-field
                    outlined
                    dense
                    prepend-inner-icon="$Search"
                    hide-details
                    label="جستجو در کد فاکتور..."
                    color="#EF6C00"
                    @input="currentPage = 1"
                    v-model.trim="codeFilter"
                    class="me-3"
                  >
                    <template v-slot:append>
                      <v-icon
                        v-if="codeFilter.length"
                        class="red--text text--lighten-2 mt-1"
                        @click="
                          codeFilter = '';
                          currentPage = 1;
                        "
                      >
                        mdi-close-circle
                      </v-icon>
                    </template>
                  </v-text-field>
                  <v-text-field
                    outlined
                    dense
                    prepend-inner-icon="$Search"
                    hide-details
                    label="جستجو در نام مشتری..."
                    color="#EF6C00"
                    v-model.trim="nameFilter"
                    @input="currentPage = 1"
                    class="me-3 mt-3 mt-md-0"
                  >
                    <template v-slot:append>
                      <v-icon
                        v-if="nameFilter.length"
                        class="red--text text--lighten-2 mt-1"
                        @click="
                          nameFilter = '';
                          currentPage = 1;
                        "
                        >mdi-close-circle</v-icon
                      >
                    </template>
                  </v-text-field>
                </div>
                <div
                  class="customSelect2 pb-0 mt-3 mt-md-0"
                  style="width: 250px; height: 45px"
                >
                  <v-icon class="me-1 ms-0 ps-0"> mdi-filter-outline </v-icon>
                  <span
                    class="pt-3 pe-2"
                    style="font-weight: normal; font-size: 14px"
                  >
                    فیلتر وضعیت
                  </span>
                  <v-select
                    dense
                    outlined
                    hide-details
                    :items="types"
                    v-model="typeFilter"
                    @change="currentPage = 1"
                  >
                    <template v-slot:append>
                      <v-icon class="shopPrimary--text">$ArrowDown</v-icon>
                    </template>
                  </v-select>
                </div>
              </v-col>
              <v-col sm="3" cols="12" class="text-sm-left text-right">
                <vue-excel-xlsx
                  v-if="computedInvoices.length"
                  :data="computedInvoices"
                  style="width: 180px; height: 43px"
                  class="darkGreen-mainBtn white--text py-2 mb-6"
                  :columns="excelFields"
                  :filename="'فاکتور فروش فروشگاه '"
                  sheetname="فاکتور فروش فروشگاه"
                >
                  <v-icon class="white--text">mdi-file-excel</v-icon> دریافت
                  اکسل
                </vue-excel-xlsx>
              </v-col>
            </v-row>

            <hr class="mt-5" />
            <div class="d-flex flex-column">
              <div class="custom-table mt-3">
                <div class="custom-table-vue">
                  <v-data-table
                    responsive
                    show-empty
                    :current-page="currentPage"
                    :items-per-page="perPage"
                    :page.sync="currentPage"
                    :items="computedInvoices"
                    :headers="headers"
                    hide-default-footer
                    no-results-text="موردی برای نمایش وجود ندارد!"
                    :single-expand="singleExpand"
                    :expanded.sync="expanded"
                    show-expand
                  >
                    <template v-slot:no-data>
                      <p class="mt-3 pt-3">موردی برای نمایش وجود ندارد</p>
                    </template>
                    <template v-slot:[`item.totalPayablePrice`]="{ item }">
                      <div>
                        {{ item.totalPayablePrice.toLocaleString()}}
                      </div>
                    </template>
                    <template v-slot:empty>
                      <div
                        style="text-align: center; vertical-align: middle"
                        class="pt-0"
                      >
                        رکوردی برای نمایش وجود ندارد.
                      </div>
                    </template>

                    <template v-slot:[`item.index`]="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 + perPage * (currentPage - 1) }}
                      </div>
                    </template>

                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                      <v-chip
                        outlined
                        :color="
                          item.status == 'در انتظار پرداخت'
                            ? '#ff7f0e'
                            : item.status == 'پرداخت شده'
                            ? '#6610f2'
                            : item.status == 'ارسال شده'
                            ? 'green'
                            : 'red'
                        "
                        class="text-center fs-xsmall pa-4"
                        style="text-align: center !important"
                      >
                        <span
                          :color="
                            item.status == 'در انتظار پرداخت'
                              ? '#ff7f0e'
                              : item.status == 'پرداخت شده'
                              ? '#6610f2'
                              : item.status == 'ارسال شده'
                              ? '#green'
                              : 'red'
                          "
                        >
                          {{ item.status }}
                        </span>
                      </v-chip>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="py-4">
                        <v-btn
                          class="pa-3 me-2 mt-2 mt-sm-0"
                          style="background-color: green; color: white"
                          width="135"
                          height="40"
                          @click="showDetails(item)"
                          ><v-icon class="me-1"> mdi-note-text </v-icon>
                          مشاهده جزییات
                        </v-btn>
                        <!-- <v-btn
                          class="pa-3 me-2 mt-2 mt-sm-0"
                          style="background-color: green; color: white"
                          width="135"
                          height="40"
                          @click="goToInvoicePage(item)"
                          v-if="item.status != 'ارسال شده'"

                        
                          ><v-icon class="me-1"> mdi-pencil-outline </v-icon>
                          ویرایش سفارش
                        </v-btn> -->
                        <v-btn
                          style="background-color: #ff7f0e; color: white"
                          width="135"
                          height="40"
                          v-if="item.status == 'در انتظار پرداخت'"
                          @click="payDialog(item)"
                          class="mt-2 mt-sm-0"
                          ><v-icon class="me-1"> mdi-cash </v-icon>
                          ثبت پرداخت
                        </v-btn>
                        <v-btn
                          style="background-color: #6610f2; color: white"
                          width="135"
                          height="40"
                          class="mt-2 mt-sm-0 me-2"
                          v-if="item.status == 'پرداخت شده'"
                          @click="send(item)"
                          ><v-icon class="me-1"> mdi-truck-outline </v-icon>

                          ارسال کالا
                        </v-btn>
                        <v-btn
                          v-if="item.status == 'پرداخت شده'"
                          :disabled="gettingReceipt"
                          class="purple white--text me-2"
                          width="135"
                          height="40"
                          @click="print(item, true)"
                          ><v-icon class="me-1">mdi-printer</v-icon>چاپ
                          رسید</v-btn
                        >
                        <v-btn
                          class="red white--text ms-2 mt-2 mt-sm-0"
                          width="135"
                          height="40"
                          @click="cancelDialog(item)"
                          v-if="item.status == 'در انتظار پرداخت'"
                        >
                          <v-icon class="me-1">mdi-close</v-icon>
                          لغو
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </div>
                <v-row class="mt-6" v-if="computedInvoices.length">
                  <v-col>
                    <div class="d-flex flex-row">
                      <span class="c-grey pt-2">نمایش در هر صفحه</span>
                      <div class="ms-3 me-3 number-box">
                        <v-select
                          outlined
                          v-model="perPage"
                          :items="perPageItems"
                          @change="currentPage = 1"
                        >
                        </v-select>
                      </div>
                    </div>
                  </v-col>
                  <v-col class="d-flex flex-row">
                    <span class="c-grey pt-2"> برو به صفحه  </span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        outlined
                        v-model="whichPage"
                      type="number"
          @change="goToPage()"
          @click="goToPage()"
          :items="computedIndex"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col class="text-sm-center">
                    <div>
                      <v-pagination
                        v-model="currentPage"
                        prev-icon="$ArrowLeft"
                        next-icon="$ArrowRight"
                        :length="Math.ceil(computedInvoices.length / perPage)"
                        :total-visible="5"
                        class="float-sm-end"
                      >
                      </v-pagination>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-container>
        </v-card>
      </v-card>

      <v-dialog v-model="openPayDialog" width="400">
        <v-card>
          <v-card-title class="white">
            <v-row>
              <v-col>
                <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                  ثبت پرداخت
                </h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="openPayDialog = false"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row>
          </v-card-title>
          <hr class="mb-3 mt-0 pt-0" />
          <v-card-text class="pa-3">
            <v-textarea
              class="pb-0"
              outlined
              placeholder="در صورت تمایل توضیحات خود را وارد نمایید"
              v-model="payDescription"
            >
            </v-textarea>
            <div class="text-left pe-3 pb-4 pt-0">
              <v-btn class="green-mainBtn me-3" @click="confirmPay()">
                تایید
              </v-btn>
              <v-btn class="red-mainBtn" @click="openPayDialog = false">
                بستن
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="openSendDialog" width="400">
        <v-card>
          <v-card-title class="white">
            <v-row>
              <v-col>
                <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                  ارسال کالا
                </h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="openSendDialog = false"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row>
          </v-card-title>
          <hr class="mt-0 pt-0" />
          <v-textarea
            class="pa-3 pb-0"
            outlined
            placeholder="در صورت تمایل توضیحات خود را وارد نمایید"
            v-model="sendDescription"
          >
          </v-textarea>
          <div class="text-left pe-3 pb-4 pt-0">
            <v-btn class="green-mainBtn me-3" @click="confirmSend()">
              تایید
            </v-btn>
            <v-btn class="red-mainBtn" @click="openSendDialog = false">
              بستن
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="openCancelDialog" width="400">
        <v-card>
          <v-card-title class="white">
            <v-row>
              <v-col>
                <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                  لغو سفارش
                </h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="openCancelDialog = false"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row>
          </v-card-title>
          <hr class="mt-0 pt-0" />
          <v-textarea
            class="pa-3 pb-0"
            outlined
            placeholder="در صورت تمایل توضیحات خود را وارد نمایید"
            v-model="cancelDescription"
          >
          </v-textarea>
          <div class="text-left pe-3 pb-4 pt-0">
            <v-btn class="green-mainBtn me-3" @click="confirmCancel()">
              تایید
            </v-btn>
            <v-btn class="red-mainBtn" @click="openCancelDialog = false">
              بستن
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="detail" width="500">
        <v-card>
          <v-card-title class="white">
            <v-row>
              <v-col>
                <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                  مشاهده جزییات فاکتور
                </h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="closeDetails"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row>
          </v-card-title>
          <hr class="mt-0 pt-0" />
          <v-card-text class="py-3 ps-6 pe-4">
            <v-row>
             <v-col class='d-flex'>
              <b class="mainFont--text"> نام مشتری: </b>
              <div class="mainFont--text ms-1">
                {{ income.shopCustomerName }}
              </div>
             </v-col>
             <v-col class='d-flex'>  <b class="mainFont--text"> شماره موبایل: </b>
              <div class="ms-1">
                {{ income.shopCustomerMobile }}
              </div></v-col>
            </v-row><v-row>
              <v-col class="d-flex"> <b class="mainFont--text"> کد فاکتور: </b>
              <div> {{ income.code }}</div> </v-col>
              <v-col class="d-flex"><b class="mainFont--text"> وضعیت : </b>  <div> {{ income.status }}</div> </v-col>
             
            </v-row>
            <v-row>
              <v-col class="d-flex"> <b class="mainFont--text"> تاریخ : </b>
              <div> {{ income.date }}</div> </v-col>
              <v-col class="d-flex"><b class="mainFont--text"> ساعت : </b>  <div> {{ income.time }}</div> </v-col>
             
            </v-row>
            <v-row class="mt-4">
             <v-col class='d-flex'> <b class="mainFont--text"> استان سکونت: </b>
              <div v-if="income.shopCustomerStateName" class="ms-1">
                {{ income.shopCustomerStateName }}
              </div>
              <div v-else class="ms-1">--</div></v-col>
              <v-col class='d-flex'>
                <b class="mainFont--text"> شهر سکونت: </b>
              <div v-if="income.shopCustomerCityName" class="ms-1">
                {{ income.shopCustomerCityName }}
              </div>
              <div v-else class="ms-1">--</div>
              </v-col>
            </v-row>
          
            <v-row class="mt-4" >
              <v-col class="d-flex ">  <b class="mainFont--text"> کد پستی: </b>
              <div v-if="income.shopCustomerPostalCode" class="ms-1">
                {{ income.shopCustomerPostalCode }}
              </div>
              <b v-else class="ms-1"> --</b></v-col>
              <v-col class="d-flex" ><b class="mainFont--text" v-if="income.shopCustomerDistrict"> منطقه سکونت: </b>
              <div class="ms-1">
                {{ income.shopCustomerDistrict }}
              </div></v-col>
            
            </v-row>
            <v-row class="mt-4">
            <v-col class="d-flex">  <b class="mainFont--text"> آدرس: </b>
              <div v-if="income.shopCustomerAddress" class="ms-1">
                {{ income.shopCustomerAddress }}
              </div>
              <div v-else class="ms-1">--</div></v-col>
            </v-row>
      
            <v-row class="mb-2 mt-4">
              <v-col><b class="shopPrimary--text"> کالاهای خریداری شده: </b></v-col>
            </v-row>
            <div class="custom-table">
              <div class="custom-table-vue">
                <v-data-table
                  responsive
                  show-empty
                  :current-page="currentPage"
                  :items-per-page="perPage"
                  :page.sync="currentPage"
                  :items="details"
                  :headers="detailsHeaders"
                  hide-default-footer
                  no-results-text="موردی برای نمایش وجود ندارد!"
                  ><template v-slot:[`item.index`]="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 + perPage * (currentPage - 1) }}
                    </div>
                  </template>

                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:[`item.price`]="{ item }">
                    <div>
                      {{ item.price.toLocaleString() }}
                    </div>
                  </template></v-data-table
                >
              </div>
            </div>
            <v-row class="mt-4">
              <v-col class="d-flex">
                <b class="mainFont--text"> جمع کل (تومان):</b>
              <div v-if="income.totalPayablePrice" class="ms-1">
                {{ income.totalPayablePrice.toLocaleString()}}
              </div>
              <div v-else class="ms-1">--</div>
              </v-col>
            </v-row>
            <v-row class="mt-4">
              <v-col class="d-flex"><b class="mainFont--text"> هزینه ارسال (تومان): </b>
              <div v-if="income.shippingCost" class="ms-1">
                {{ income.shippingCost.toLocaleString()}}
              </div>
              <div v-else class="ms-1">--</div></v-col>
            </v-row>
            <v-row class="mt-4">
             <v-col class="d-flex"> <b class="mainFont--text"> مبلغ قابل پرداخت (تومان):</b>
              <div v-if="income.totalPayablePrice" class="ms-1">
                {{income.totalPayablePrice.toLocaleString()}}
              </div>
              <div v-else class="ms-1">--</div></v-col>
            </v-row>
           
          </v-card-text>
          <div class="text-left pe-3 pb-4 pt-0">
            <v-btn class="red-mainBtn" @click="closeDetails"> بستن </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <v-card>
      <div id="Receipt" v-show="false" v-if="!gettingReceipt">
        <div class="mainTable" style="width: 100%; height: 100%">
          <div style="margin-bottom: 15px">
            <div
              style="text-align: center; width: 100%"
              class="d-flex flex-column"
            >
              <div><img src="/pen.png" height="100px" alt="" /></div>
              <div class="mt-10">
                <b class="text-center mx-auto">کتاب‌ باز</b>
              </div>
            </div>
          </div>
          <tbody>
            <tr>
              <td>
                <div
                  class="content"
                  style="padding: 5px 0; margin-bottom: 15px"
                >
                  <div>
                    <div>
                      <div style="text-align: center">
                        <strong style="font-size: 17px"
                          >{{ income.shopCustomerName }} عزیز، از اینکه فروشگاه
                          آنلاین ما رو انتخاب کردی خیلی ممنونیم :)
                        </strong>
                      </div>
                      <table
                        v-if="income.shopCustomerName"
                        style="
                          border: 0px solid black !important;
                          margin-top: 15px;
                        "
                      >
                        <tr>
                          <td style="border: 0px solid black !important">
                            تاریخ خرید:
                            {{ income.date }}
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            <span style="font-size: 16px">
                              {{ income.code }}
                            </span>
                          </td>
                        </tr>
                      </table>
                      <table
                        style="
                          border: 0px solid black !important;
                          margin-top: 15px;
                        "
                      >
                        <tr>
                          <td style="border: 0px solid black !important">
                            نام مشتری:
                            {{ income.shopCustomerName }}
                          </td>
                        </tr>
                        <tr>
                          <td style="border: 0px solid black !important">
                            موبایل مشتری:
                            {{ income.shopCustomerMobile }}
                          </td>
                        </tr>
                        <tr>
                          <td style="border: 0px solid black !important">
                            آدرس مشتری:
                            {{ income.addressForReceipt }}
                          </td>
                        </tr>
                      </table>

                      <br />
                    </div>
                  </div>
                  <b-table
                    v-if="income.details"
                    bordered
                    :fields="selectedFields"
                    :items="income.details"
                    small="small"
                    responsive
                  >
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell(name)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(amount)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value.toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(price)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(totalPrice)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{
                          (
                            Number(data.item.amount) * data.item.price
                          ).toLocaleString()
                        }}
                      </div>
                    </template>
                  </b-table>

                  <br />
                  <table
                    v-if="income.details"
                    style="
                      border: 0px solid black !important;
                      padding: 0 !important;
                      width: 100%;
                      margin-bottom: 10px;
                    "
                  >
                    <tr style="margin-bottom: 15px">
                      <td style="border: 0px solid black !important">
                        جمع اقلام:
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size = 16px"
                          >{{
                            income.details
                              .map((x) => Number(x.amount))
                              .reduce((a, b) => a + b, 0)
                          }}
                          عدد
                        </span>
                      </td>
                    </tr>

                    <tr style="margin-bottom: 15px">
                      <td style="border: 0px solid black !important">
                        جمع کل (تومان):
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size = 16px"
                          >{{ income.totalPayablePrice.toLocaleString() }}
                        </span>
                      </td>
                    </tr>

                    <tr style="margin-bottom: 15px">
                      <td style="border: 0px solid black !important">
                        هزینه ارسال (تومان):
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size = 16px"
                          >{{
                            income.shippingCost
                              ? income.shippingCost.toLocaleString()
                              : "رایگان"
                          }}
                        </span>
                      </td>
                    </tr>
                  </table>

                  <div class="totalCost" style="padding: 0 10px !important">
                    <table
                      v-if="income.totalPayablePrice"
                      style="border: 0px solid black !important"
                    >
                      <tr>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: center;
                          "
                        >
                          مبلغ قابل پرداخت (تومان):
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: center;
                          "
                        >
                          <span style="font-size = 16px"
                            >{{
                              parseInt(
                                income.totalPayablePrice
                              ).toLocaleString()
                            }}
                          </span>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="mt-3" v-if="income.description != '-'">
                    توضیحات: {{ income.description }}
                  </div>
                  <br />

                  <br />
                  <div class="bot-box">
                    <div>shop.acepetclub.com</div>
                    <div>اینستاگرام: ace_pet_club</div>
                    <div>شماره تماس: 09124061268</div>
                    <div>
                      بلوار اندرزگو - بلوار صبا - کوچه کیارنک - نبش کوچه مقدم
                    </div>                   
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </div>
      </div>
    </v-card>
    <!-- receipt -->
    <br />
    <router-view></router-view>
  </div>
</template>
<script>
import Axios from "axios";
import { AtomSpinner } from "epic-spinners";
import VueBarcode from "vue-barcode";

export default {
  components: {
    AtomSpinner,
    barcode: VueBarcode,
  },
  data() {
    return {
      loaded: false,
      gettingReceipt: false,
      codeFilter: "",
      nameFilter: "",
      typeFilter: "همه",
      currentPage: 1,
      types: ["همه", "در انتظار پرداخت", "پرداخت شده", "ارسال شده", "لغو شده"],
      selectedRequest: {},
      selectedPaid: {},
      invoices: [],
      perPage: 5,
      perPageItems: [5, 10, 20],
      headers: [
        { value: "index", text: "ردیف", sortable: false },
        { value: "shopCustomerName", text: "نام مشتری", sortable: false },
        { value: "invoiceCode", text: "کد فاکتور", sortable: false },
        { value: "date", text: "تاریخ", sortable: false },
        { value: "time", text: "ساعت", sortable: false },
        { value: "totalPayablePrice", text: "مبلغ(تومان)", sortable: false },
        { value: "status", text: "وضعیت", sortable: false },
        { value: "data-table-expand", text: "عملیات", sortable: false },
      ],
      excelFields: [
        // { field: "index", label: "ردیف" },
        { field: "shopCustomerName", label: "نام مشتری" },
        { field: "invoiceCode", label: "کد فاکتور" },
        { field: "date", label: "تاریخ" },
        { field: "time", label: "ساعت" },
        { field: "totalPayablePrice", label: "مبلغ" },
        { field: "status", label: "وضعیت" },
      ],
      detailsHeaders: [
        { value: "index", text: "ردیف", sortable: false },
        { value: "name", text: "نام کالا", sortable: false },
        { value: "amount", text: "تعداد ", sortable: false },
        { value: "price", text: "مبلغ ", sortable: false },
      ],
      selectedFields: [
        // { key: "index", label: "ردیف" },
        { key: "name", label: "نام کالا" },
        { key: "price", label: "قیمت واحد (تومان)" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "جمع کل (تومان)" },
      ],
      openPayDialog: false,
      openSendDialog: false,
      openCancelDialog: false,
      sendDescription: "",
      payDescription: "",
      cancelDescription: "",
      singleExpand: false,
      expanded: [],
      shopCustomerAddress: "",
      income: {},
      details: [],
      detail: false,
      whichPage:1,
    };
  },
  methods: {
    goToPage(){
      this.currentPage=Number(this.whichPage);
    },
    goToInvoicePage(item){
      this.$router.push('/shop/editinvoice/'+ item.id)
    },
    getList() {
      Axios.get(this.baseUrl + "/satrapp/shop/sales/listOnlineInvoices", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.loaded = true;
            this.invoices = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.loaded = true;
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.loaded = true;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    payDialog(item) {
      this.openPayDialog = true;
      this.selectedRequest = item;
    },
    cancelDialog(item) {
      this.openCancelDialog = true;
      this.selectedRequest = item;
    },
    confirmPay() {
      Axios.post(
        this.baseUrl +
          "/satrapp/shop/payments/submitIncome/" +
          this.selectedRequest.id,
        { description: this.payDescription },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.selectedRequest.status = "پرداخت شده";
            this.selectedRequest = {};
            this.openPayDialog = false;
            this.payDescription = "";
            this.getList();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.openPayDialog = false;
            this.selectedRequest = {};
            this.payDescription = "";
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.openPayDialog = false;
          this.selectedRequest = {};
          this.payDescription = "";
        });
    },
    send(item) {
      this.openSendDialog = true;
      this.selectedPaid = item;
    },
    confirmSend() {
      Axios.post(
        this.baseUrl +
          "/satrapp/shop/sales/shipInvoice/" +
          this.selectedPaid.id,
        { description: this.sendDescription },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.selectedPaid.status = "ارسال شده";
            this.selectedPaid = {};
            this.openSendDialog = false;
            this.sendDescription = "";
            this.getList();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.openSendDialog = false;
            this.sendDescription = "";
            this.selectedPaid = {};
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.openSendDialog = false;
          this.sendDescription = "";
          this.selectedPaid = {};
        });
    },
    confirmCancel() {
      Axios.patch(
        this.baseUrl +
          "/satrapp/shop/sales/cancelOnlineInvoice/" +
          this.selectedRequest.id,
        { description: this.cancelDescription },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.selectedRequest.status = "لغو شده";
            this.openCancelDialog = false;
            this.selectedRequest = {};
            this.cancelDescription = "";
            this.getList();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");

            this.openCancelDialog = false;
            this.selectedRequest = {};
            this.cancelDescription = "";
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.openCancelDialog = false;
          this.selectedRequest = {};
          this.cancelDescription = "";
        });
    },
    showDetails(item) {
this.loaded=false;

      Axios.post(
        this.baseUrl + "/satrapp/shop/sales/getInfo",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.loaded=true;
            this.income = res.data;
            this.details = res.data.details;
             this.detail = true;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    closeDetails() {
      this.detail = false;
      this.details = [];
      this.income = {};
    },
    print(item, forcePrint) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/sales/getInfo",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.income = res.data;
            this.details = res.data.details;
            setTimeout(() => {
              this.printReceipt();
            }, 1000);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "Receipt", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><link rel='stylesheet' href='/receipt.css'><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("Receipt").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
  },
  mounted() {
    this.getList();
  },
  computed: {
    computedInvoices() {
      let filtered;
      if (this.typeFilter == "همه" && this.invoices.length) {
        filtered = this.invoices.filter(
          (x) =>
            x.shopCustomerName.includes(this.nameFilter) &&
            x.invoiceCode.toLowerCase().includes(this.codeFilter.toLowerCase())
        );
      } else {
        filtered = this.invoices.filter(
          (x) =>
            x.shopCustomerName.includes(this.nameFilter) &&
            x.invoiceCode
              .toLowerCase()
              .includes(this.codeFilter.toLowerCase()) &&
            x.status == this.typeFilter
        );
      }
      return filtered;
    },
    computedIndex(){ 
    let arr=[];
let computedLength=this.computedInvoices.length;
let arrLength= Math.ceil(computedLength/this.perPage);
for(let i=1 ; i <= arrLength; i++){
  arr.push(i);
}
return arr;
  },
  },
};
</script>
<style lang="scss">

.customSelect2 {
  .v-input__slot {
    width: 120px !important;
  }
  .v-select__selection--comma {
    font-size: 14px !important;
  }
}
.custom-input {
  .v-input__slot {
    width: 210px !important;
  }
  .v-input__control {
    flex-direction: row !important;
  }
  .v-text-field .v-input__control,
  .v-text-field fieldset {
    min-height: 45px !important;
    border-color: #EF6C00 !important;
  }
  .v-label:not(.v-label--active) {
    transform: translateY(2px);
  }
}
.v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.custom-input {
  .v-input__slot {
    width: 210px !important;
  }
  .v-input__control {
    flex-direction: row !important;
  }
  .v-text-field .v-input__control,
  .v-text-field fieldset {
    min-height: 45px !important;
    border-color: #EF6C00 !important;
  }
  .v-label:not(.v-label--active) {
    transform: translateY(2px);
  }
  .theme--light.v-data-table .v-data-table-header th.sortable:hover {
    color: white !important;
  }
  .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th {
    color: white !important;
  }
  .v-data-table
    > .v-data-table__wrapper
    tbody
    tr.v-data-table__expanded__content {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }
  .theme--light.v-card > .v-card__subtitle,
  .theme--light.v-card > .v-card__text {
    color: black !important;
  }
  .theme--light.v-data-table {
    background-color: #fff;
    color: black !important;
  }
  table thead {
    color: black !important;
  }
  .custom-table-vue .v-data-table-header tr th {
    text-align: center !important;
    font-size: 15px !important;
    color: black !important;
    height: 50px !important;
  }
}
</style>
